import { sanitizeInput } from '@shared/utils/sanitize-input/sanitizeInput';
import { z } from 'zod';

const sanitize = (v: unknown): string =>
  sanitizeInput(typeof v === 'string' ? v : undefined) ?? '';

export const editOtherInformationSchema = z.object({
  nickName: z.preprocess(
    sanitize,
    z.string().trim().max(40, 'Cannot exceed 40 characters')
  )
});

export type EditOtherInformationFormData = z.infer<typeof editOtherInformationSchema>;
